import api from "./api";

export async function getUserCurrent() {
	try {
		const response = await api.get("/api/auth/user/profile");
		const data = response.data;

		const rolesArray: string[] = Array.isArray(data?.roles) ? data.roles : [];
		const normalizedRoles = rolesArray.map((r) => r.toLowerCase());

		return {
			id: data?.id || "",
			fullName: data?.fullName || "",
			email: data?.email || "",
			role: normalizedRoles,
		};
	} catch (error) {
		throw error;
	}
}
